const useSSL = process.env.REACT_APP_USE_SSL === 'true'
const useDesktop = process.env.DESKTOP_MODE === '1'
const isProduction = process.env.NODE_ENV === 'production'

const browserOrigin = typeof window !== 'undefined' ? window.location.origin : ''

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const toWebSocketOrigin = (origin: string) =>
  trimTrailingSlash(origin).replace(/^http(s?):\/\//, 'ws$1://')

const getDefaultDevApiOrigin = () =>
  useDesktop ? 'http://localhost:3333' : 'http://localhost:8000'

const getDefaultDevWebSocketOrigin = () =>
  useDesktop ? 'ws://localhost:3333' : 'ws://localhost:8000'

const getDevApiBaseUrl = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

  if (apiBaseUrl) {
    return trimTrailingSlash(apiBaseUrl)
  }

  if (useSSL && browserOrigin) {
    return trimTrailingSlash(browserOrigin)
  }

  return getDefaultDevApiOrigin()
}

const getDevSocketBaseUrl = () => {
  const socketBaseUrl = process.env.REACT_APP_WS_BASE_URL

  if (socketBaseUrl) {
    return trimTrailingSlash(socketBaseUrl)
  }

  if (useSSL && browserOrigin) {
    return `${toWebSocketOrigin(browserOrigin)}/ws/ui`
  }

  return `${getDefaultDevWebSocketOrigin()}/ws/ui`
}

export const API_BASE_URL =
  isProduction && browserOrigin ? trimTrailingSlash(browserOrigin) : getDevApiBaseUrl()

export const SOCKET_BASE_URL =
  isProduction && browserOrigin
    ? `${toWebSocketOrigin(browserOrigin)}/ws/ui`
    : getDevSocketBaseUrl()
